<template>
  <!-- where we will plot our children views under this route -->
  <router-view />
  <!-- where we will plot our children views under this route -->
</template>

<script>
// @ is an alias to /src
export default {
  name: "DefaultView",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  computed() {},

  methods: {},
};
</script>

<style></style>
